import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { Popover, MaterialIcon, SVGIcon } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import ImportReportDownload from '../ImportReportDownload';
import { Header,
  HeaderTitle,
  CloseButton,
  Container,
  MessageLine,
  StyledParagraph } from './styles';
import messages from './messages';

const INFOTYPE = Object.freeze({
  WARN: 'warn',
  FAIL: 'fail',
});

const ImportInfoPopover = (props) => {
  const {
    onClose,
    infoType,
    theme,
    courseName,
    ingestionId,
    ingestionStats,
    showWarnings,
    ingestionType,
  } = props;

  const iconColor = Object.freeze({
    [INFOTYPE.WARN]: theme['color.orangeLight'],
    [INFOTYPE.FAIL]: theme['color.redDark'],
  });

  const iconType = 'warningCircle';
  return (
    <Popover width={410} popperOptions={{ placement: 'right' }} {...props}>
      <Container>
        <Header>
          <SVGIcon size="large" fill={iconColor[infoType]} icon={iconType} />
          <HeaderTitle>{intl.formatMessage(messages[`${infoType}HeaderInfo${ingestionType}`])}</HeaderTitle>
        </Header>
        <MessageLine>
          {infoType == INFOTYPE.FAIL ? <StyledParagraph>{intl.formatMessage(messages.ingestionIdLabel)}<br /> {ingestionId}</StyledParagraph> : ''}
          {intl.formatMessage(messages.warnAdditionalInfo)}
        </MessageLine>
        {showWarnings && (
          <div>
            {Object.keys(ingestionStats).map(
              (statType) => <StyledParagraph key={statType?.replace(/\s/g, '')} >{ingestionStats[statType]} {statType}</StyledParagraph>
            )}
          </div>
        )}
        <ImportReportDownload
          ingestionStats={ingestionStats}
          courseName={courseName}
          ingestionId={ingestionId}
          ingestionType={ingestionType} />
        <CloseButton grey iconOnly onClick={onClose}>
          <MaterialIcon id="close" />
        </CloseButton>
      </Container>
    </Popover>
  );
};

ImportInfoPopover.propTypes = {
  onClose: PropTypes.func,
  infoType: PropTypes.string,
  theme: PropTypes.object,
  courseName: PropTypes.string,
  ingestionId: PropTypes.string,
  ingestionStats: PropTypes.object,
  showWarnings: PropTypes.bool,
  ingestionType: PropTypes.string,
};

export default withTheme(ImportInfoPopover);
